export default "__VITE_ASSET__D3h78eg7__"